import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { updateRegistration } from '../../../../services/RegistrationService/registrationSlice/';

const LastNameEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const name = useAppSelector(state => state.registration.currentRegistration?.name) || {};
  const value = name.last || '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRegistration({
      name: {
        ...name,
        last: e.target.value,
      },
    }));
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      size="small"
      label="Last Name"
      required
    />
  );
};

export default LastNameEdit;
